/*
 * PatientDataPage Messages
 *
 * This contains all the text for the PatientDataPage container.
 */

import {defineMessages} from "react-intl";

export const scope = "app.containers.PatientDataPage";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "Patient overview",
  },
  noPlannedTreatments: {
    id: `${scope}.noPlannedTreatments`,
    defaultMessage:
      "There are currently no planned appointments for this patient",
  },
  planNewAppointment: {
    id: `${scope}.planNewAppointment`,
    defaultMessage: "Plan a new appointment",
  },
  closeTreatmentPlan: {
    id: `${scope}.closeTreatmentPlan`,
    defaultMessage: "Complete treatment plan",
  },
  closeProductPlan: {
    id: `${scope}.closeProductPlan`,
    defaultMessage: "Complete product plan",
  },
  closeTreatmentPlanConfirm: {
    id: `${scope}.closeTreatmentPlanConfirm`,
    defaultMessage: "Are you sure you want to complete this treatment plan?",
  },
  closeProductPlanConfirm: {
    id: `${scope}.closeProductPlanConfirm`,
    defaultMessage: "Are you sure you want to complete this product plan?",
  },
  noProductPlan: {
    id: `${scope}.noProductPlan`,
    defaultMessage: "There's no active product plan for this patient. Please press the button 'Order product' to start a new product plan.",
  },
  noTreatmentPlan: {
    id: `${scope}.noTreatmentPlan`,
    defaultMessage: "There's no active treatment plan for this patient. Please press the button 'Plan a new appointment' to start a new treatment plan.",
  },
  closeTreatmentPlanNotAllowedConfirm: {
    id: `${scope}.closeTreatmentPlanNotAllowedConfirm`,
    defaultMessage:
      "You want to make a change or cancellation to an appointment whose schedule is already set. Contact Refrezh by telephone so that we can jointly find a suitable solution and change or cancel the appointment. Call ReFrezh: 088-700 5588 ",
  },
  headerTitle: {
    id: `${scope}.headerTitle`,
    defaultMessage: "Patient",
  },
  subTitle: {
    id: `${scope}.subTitle`,
    defaultMessage: "Patient nr. ",
  },
  orderProduct: {
    id: `${scope}.orderProduct`,
    defaultMessage: "Order Product",
  },

  caseNo: {
    id: `${scope}.caseNo`,
    defaultMessage: "Case no.:",
  },
  patientNo: {
    id: `${scope}patientNo`,
    defaultMessage: "Patient no.",
  },
  confirmDeletePatient: {
    id: `${scope}.confirmDeletePatient`,
    defaultMessage: "Are you sure you want to delete this patient?",
  },
  confirmDeleteWarningPatient: {
    id: `${scope}.confirmDeleteWarningPatient`,
    defaultMessage: "First delete all scheduled appointments",
  },
  confirmDeleteWarningHeader: {
    id: `${scope}.confirmDeleteWarningHeader`,
    defaultMessage: "Delete Patient",
  },
  filterAll: {
    id: `${scope}.filterAll`,
    defaultMessage: "All",
  },
  filterOpen: {
    id: `${scope}.filterOpen`,
    defaultMessage: "Open",
  },
  filterClosed: {
    id: `${scope}.filterClosed`,
    defaultMessage: "Processed",
  },

  previewInPatient: {
    id: `${scope}.previewInPatient`,
    defaultMessage: "View in patient card",
  },
  delete_patient_title: {
    id: `${scope}.delete_patient_title`,
    defaultMessage: "Delete patient",
  },
  delete_patient_content: {
    id: `${scope}.delete_patient_content`,
    defaultMessage: "Are you sure you want to delete this patient?",
  },
  delete_patient_cancel: {
    id: `${scope}.delete_patient_cancel`,
    defaultMessage: "Cancel",
  },
  delete_patient_confirm: {
    id: `${scope}.delete_patient_confirm`,
    defaultMessage: "Delete",
  },
  remake_product_upper_jaw: {
    id: `${scope}.remake_product_upper_jaw`,
    defaultMessage: "Product upper jaw",
  },
  remake_product_lower_jaw: {
    id: `${scope}.remake_product_lower_jaw`,
    defaultMessage: "Product lower jaw",
  },
  remake_product_remake: {
    id: `${scope}.remake_product_remake`,
    defaultMessage: "Remake",
  },
  remake_product_make_changes: {
    id: `${scope}.remake_product_make_changes`,
    defaultMessage: "Make changes",
  },
  remake_product_yes: {
    id: `${scope}.remake_product_yes`,
    defaultMessage: "Yes",
  },
  remake_product_no: {
    id: `${scope}.remake_product_no`,
    defaultMessage: "No",
  },
  remake_product_confirm: {
    id: `${scope}.remake_product_confirm`,
    defaultMessage: "Confirm",
  },
  remake_product_title: {
    id: `${scope}.remake_product_title`,
    defaultMessage: "Remake request",
  },
  refitting_remake_product_title: {
    id: `${scope}.refitting_remake_product_title`,
    defaultMessage: "Refitting remake request",
  },
  remake_product_title_warranty: {
    id: `${scope}.remake_product_title_warranty`,
    defaultMessage: "Warranty request",
  },
  warranty_popover_info: {
    id: `${scope}.warranty_popover_info`,
    defaultMessage:
      "Do you want a remake with or without changes or the money back? We will review the application as soon as possible and determine whether it is covered by the warranty scheme. If the warranty is applied, the current prosthesis must be returned. There may be additional costs to a remake.",
  },
  remake_popover_info: {
    id: `${scope}.remake_popover_info`,
    defaultMessage:
      "Do you want a remake or also changes? We will review the request as soon as possible and contact you if necessary. There may be additional costs to a remake.",
  },
  remake_product_comment: {
    id: `${scope}.remake_product_comment`,
    defaultMessage: "Description of the reasons",
  },
  new_patient_title: {
    id: `${scope}.new_patient_title`,
    defaultMessage: "New patient",
  },
  message_type_all: {
    id: `${scope}.message_type_all`,
    defaultMessage: "All",
  },
  message_type_orders: {
    id: `${scope}.message_type_orders`,
    defaultMessage: "Orders",
  },
  message_type_appointments: {
    id: `${scope}.message_type_appointments`,
    defaultMessage: "Appointments",
  },
  message_type_other: {
    id: `${scope}.message_type_other`,
    defaultMessage: "Other",
  },
  message_type_notifications: {
    id: `${scope}.message_type_notifications`,
    defaultMessage: "Notifications",
  },
});
